import React, { useState, useEffect } from "react";
import "./GoogleReviewsPanel.scss";
import { FaStar, FaGoogle, FaTimes } from "react-icons/fa";
import { getHotelGoogleReviews } from "../../services/googleReviewsService";
import { useGoogleReviews } from "../../contexts/GoogleReviewsContext";

const GoogleReviewsPanel = () => {
  const { isOpen, hotelName, city, address, closePanel } = useGoogleReviews();
  const [reviewsData, setReviewsData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen && hotelName && city) {
      setLoading(true);
      setError(null);
      setReviewsData(null); // Clear previous data
      
      getHotelGoogleReviews(hotelName, city, address)
        .then((data) => {
          setReviewsData(data);
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error loading reviews for panel:", err);
          setError("שגיאה בטעינת ביקורות");
          setLoading(false);
        });
    } else if (!isOpen) {
      // Clear data when panel closes
      setReviewsData(null);
      setError(null);
      setLoading(false);
    }
  }, [isOpen, hotelName, city, address]);

  if (!isOpen) return null;

  // Show all reviews (no Hebrew filtering)
  const allReviews = reviewsData?.reviews || [];
  const { rating, ratingsCount } = reviewsData || {};

  return (
    <>
      {/* Overlay */}
      <div className="google-reviews-panel-overlay" onClick={closePanel} />
      
      {/* Panel */}
      <div className="google-reviews-panel open">
        <div className="google-reviews-panel-header">
          <div className="panel-header-content">
            <div className="panel-title-section">
              <FaGoogle className="google-icon" />
              <div>
                <h2 className="panel-title">ביקורות גוגל</h2>
                {hotelName && (
                  <p className="panel-subtitle">{hotelName}</p>
                )}
              </div>
            </div>
            {rating && (
              <div className="panel-rating">
                <FaStar className="star-icon" />
                <span className="rating-value">{rating.toFixed(1)}</span>
                {ratingsCount > 0 && (
                  <span className="ratings-count">
                    ({ratingsCount.toLocaleString()} ביקורות)
                  </span>
                )}
              </div>
            )}
          </div>
          <button className="panel-close-button" onClick={closePanel}>
            <FaTimes />
          </button>
        </div>

        <div className="google-reviews-panel-content">
          {loading ? (
            <div className="panel-loading">
              <span>טוען ביקורות...</span>
            </div>
          ) : error ? (
            <div className="panel-error">
              <span>{error}</span>
            </div>
          ) : !reviewsData ? (
            <div className="panel-empty">
              <span>לא נמצאו ביקורות</span>
            </div>
          ) : allReviews.length === 0 ? (
            <div className="panel-empty">
              <span>לא נמצאו ביקורות</span>
            </div>
          ) : (
            <>
              <div className="panel-reviews-header">
                <span className="reviews-count">
                  {allReviews.length} ביקורות
                </span>
              </div>
              
              <div className="panel-random-notice">
                <span className="notice-icon">ℹ️</span>
                <span className="notice-text">
                  הביקורות המוצגות הן בחירה אקראית של Google ולא בהכרח החדשות ביותר
                </span>
              </div>
              
              <div className="panel-reviews-list">
                {allReviews.map((review, index) => (
                  <div key={index} className="panel-review-item">
                    <div className="review-header">
                      <div className="review-author">{review.author}</div>
                      <div className="review-rating">
                        {Array.from({ length: 5 }, (_, i) => (
                          <FaStar
                            key={i}
                            className={`star ${i < review.rating ? "filled" : "empty"}`}
                          />
                        ))}
                      </div>
                    </div>
                    {review.text && (
                      <div className="review-text">{review.text}</div>
                    )}
                    {review.relativeTime && (
                      <div className="review-time">{review.relativeTime}</div>
                    )}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default GoogleReviewsPanel;

